class Core {
    constructor() {}

    getName = () => {
        // @ts-ignore
        return this.name;
    };

    getIsInit = () => {
        // @ts-ignore
        return this.state.isInit;
    };
}

export default Core;
